/**
 * 语言工具函数（单一事实来源）
 * - 检测顺序：localStorage > 默认值（忽略浏览器语言）
 * - 不依赖 i18n 实例或 Vuex store，避免循环依赖
 */

import { getStorage } from '@/utils/browserStorage'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './config'

/**
 * 判断语言是否受支持
 */
export function isLocaleSupported(locale) {
  return SUPPORTED_LOCALES.includes(locale)
}

/**
 * 从浏览器获取首选语言
 */
export function getBrowserLocale() {
  // 当前需求：忽略浏览器语言检测，直接返回默认值
  return DEFAULT_LOCALE
}

/**
 * 从 localStorage 读取并校验已保存的语言设置
 */
export function getSavedLocale() {
  try {
    const saved = getStorage('lang')
    if (saved && isLocaleSupported(saved)) return saved
  } catch (err) {
    // 忽略错误，使用后续回退逻辑
  }
  return null
}

/**
 * 解析初始语言（不访问 store/i18n）
 */
export function getInitialLocale() {
  // 言語切替 UI を撤去し、画面は日本語（DEFAULT_LOCALE）に統一。
  // 過去に localStorage に保存された言語は無視する（切替 UI 復活時は getSavedLocale() を優先に戻す）。
  return DEFAULT_LOCALE
}
